const stringParameterize = (string, separator = '-') => {
  return string
    .replace(/[^a-z0-9\-_]+/gi, separator)
    .replace(new RegExp(`${separator}{2,}`, 'g'), separator)
    .replace(new RegExp(`^${separator}|${separator}$`, 'g'), '')
    .toLowerCase();
};

export default stringParameterize;
